(() => {
	const init = (section) => {
		const track = section.querySelector('.campaign-feature-slider__track');
		const slides = [...section.querySelectorAll('.campaign-feature-slider__slide')];
		const progress = section.querySelector('[data-campaign-feature-slider="progress"]');

		if (!track || !slides.length || !progress) {
			return;
		}

		const previous = section.querySelector('[data-campaign-feature-slider="previous"]');
		const next = section.querySelector('[data-campaign-feature-slider="next"]');
		const indicator = document.createElement('span');
		indicator.className = 'campaign-feature-slider__progress-indicator';
		progress.replaceChildren(indicator);

		const currentIndex = () => {
			const left = track.scrollLeft;

			return slides.reduce((closest, slide, index) => {
				const slideDistance = Math.abs(slide.offsetLeft - track.offsetLeft - left);
				const closestDistance = Math.abs(
					slides[closest].offsetLeft - track.offsetLeft - left
				);

				return slideDistance < closestDistance ? index : closest;
			}, 0);
		};

		const update = () => {
			const slideWidth = slides[0].getBoundingClientRect().width;
			const visible = Math.max(1, Math.round(track.clientWidth / slideWidth));
			const steps = Math.max(1, slides.length - visible + 1);
			const index = Math.min(currentIndex(), steps - 1);

			indicator.style.width = `${100 / steps}%`;
			indicator.style.transform = `translateX(${index * 100}%)`;

			if (previous) {
				previous.disabled = index === 0;
			}

			if (next) {
				next.disabled = index === steps - 1;
			}
		};

		const move = (direction) => {
			const styles = getComputedStyle(track);
			const gap = parseFloat(styles.columnGap || styles.gap) || 0;
			const slideWidth = slides[0].getBoundingClientRect().width;

			track.scrollBy({
				left: direction * (slideWidth + gap),
				behavior: 'smooth',
			});
		};

		if (previous) {
			previous.addEventListener('click', () => move(-1));
		}

		if (next) {
			next.addEventListener('click', () => move(1));
		}

		track.addEventListener('scroll', update, { passive: true });
		window.addEventListener('resize', update);
		update();
	};

	const boot = () => {
		document.querySelectorAll('.campaign-feature-slider').forEach(init);
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else {
		boot();
	}
})();
